import { render, staticRenderFns } from "./PrimsEditor.vue?vue&type=template&id=f3a255ae"
import script from "./PrimsEditor.vue?vue&type=script&lang=js"
export * from "./PrimsEditor.vue?vue&type=script&lang=js"
import style0 from "./PrimsEditor.vue?vue&type=style&index=0&id=f3a255ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports